<template>
  <div class="lyf-ui-bottom-tip" :style="{
    marginTop: marginTop + 'px'
  }">{{ text }}</div>
</template>

<script>
export default {
  name: 'LyfBottomTip',
  props: {
    marginTop: {
      type: [Number, String],
      default: 0
    },
    text: {
      type: String,
      default: '- Hi !你碰到我的底线了 -'
    }
  }
}
</script>

<style scoped>
.lyf-ui-bottom-tip {
  padding: 12px 16px;
  color: var(--font-color_3);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
</style>